import { CONFIG } from './config';

/** Parse a free-typed amount ("1'000'000", "1.000.000", "1000000") to an integer. */
export function parseAmount(value: string): number {
  const digits = value.replace(/[^\d]/g, '');
  return digits ? parseInt(digits, 10) : 0;
}

/** Group with the Swiss thousands separator; empty string for 0/blank. */
export function formatThousands(n: number): string {
  return n > 0 ? n.toLocaleString(CONFIG.locale) : '';
}

/** "CHF 1’234’567" (rounded). */
export function chf(n: number): string {
  return 'CHF ' + Math.round(n).toLocaleString(CONFIG.locale);
}

/** "24.2%" */
export function pct(n: number, digits = 1): string {
  return (n * 100).toLocaleString(CONFIG.locale, { maximumFractionDigits: digits }) + '%';
}
